import Http from "../network/Http";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

const HEADR_KEYS = [
  "key",
  "x-amz-algorithm",
  "x-amz-credential",
  "x-amz-date",
  "policy",
  "x-amz-signature",
];

const upload = async (files, SignedResponse, fileNames) => {
  let fileResponse = [];
  try {
    for (let i = 0; i < files?.length; i++) {
      const formData = new FormData();
      let file = files?.[i];
      let fileName = fileNames?.[i];
      let HEADER_VALUES = SignedResponse?.[i]?.fields;
      let URL = SignedResponse?.[i]?.url;
      console.log(file, HEADER_VALUES, URL);
      for (let i = 0; i < HEADR_KEYS?.length; i++) {
        formData.append(HEADR_KEYS[i], HEADER_VALUES?.[HEADR_KEYS[i]]);
      }
      formData.append("file", file);
      let headers = {};
      headers["Content-Type"] = "multipart/form-data";
      headers = { headers };
      console.log("file response", URL + "" + fileName);

      let response = await axios.post(URL, formData, headers);
      console.log("file response", response, URL + "" + fileName);
      if (response?.status == "204") {
        let uploadedFile = {};
        let uploadURL = URL + "" + fileName;
        uploadedFile["originalURL"] = uploadURL;
        uploadedFile["fileName"] = getFileName(fileName);
        uploadedFile["mimeType"] = file?.type;
        uploadedFile["url"] = uploadURL;

        console.log("uploadedFile", uploadedFile);
        uploadedFile && fileResponse.push(uploadedFile);
      }
    }
  } catch (e) {
    console.log(e);
    console.log("file response error ", e);
  }
  return fileResponse;
};
const getFileName = (str) => {
  const parts = str.split("/");
  return parts?.[parts.length - 1];
};
const getSignedURL = async (files, module) => {
  let fileResponse = {};
  try {
    let inputData = [];
    for (const file of files) {
      let fileName = "" + uuidv4() + "_" + file?.name?.replace(/ /g, "_");
      inputData.push(fileName);
    }
    let data = {
      files: inputData,
      module,
    };
    let response = await Http.post("/upload", JSON.stringify(data));
    fileResponse.signedResponse = response?.data?.data || [];
    fileResponse.fileNames = inputData;
  } catch (e) {
    console.log(e);
  }
  return fileResponse;
};

export const fileUpload = async (files, moduleName) => {
  let filesResponse = [];
  try {
    if (!Array.isArray(files)) {
      files = [files];
    }
    let response = await getSignedURL(files, moduleName);
    let { signedResponse, fileNames } = response;
    if (signedResponse?.length > 0) {
      filesResponse = await upload(files, signedResponse, fileNames);
    }
    console.log("uploaded files", filesResponse);
  } catch (e) {
    console.log("error", e);
  }
  return filesResponse;
};
